<template>
    <section class="contain">
        <div class="inner" :style="{ minHeight: screenHeight }">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h1 class="panel-title">New Booking</h1>
                </div>
                <div class="panel-body">
                    <!-- <h4>
                        To take advantage of our conference rate at the Vida Dubai Marina & Yacht Club
                    </h4>

                    <ul class="mr-l-40">
                        <li class="dot-list">
                            <b> Please <a class="link-style text-underline"
                                    href="https://reservations.travelclick.com/115086?groupID=4170603">click here</a> to
                                book your room </b>. Booking terms and conditions are enclosed in the link.
                        </li>
                        <li class="dot-list">
                            This special rate is applicable for bookings made between <b> March 2<sup>nd</sup> and March
                                8<sup>th</sup> 2024.</b>
                        </li>
                        <li class="dot-list">
                            Due to high demand and limited room availability,<b> room rates and availability are offered on
                                a first-come, first-served basis.</b>
                        </li>
                        <li class="dot-list">
                            For any further inquiries, please email <a class="link-style text-underline"
                                href="mailto:groups@emaar.ae"> groups@emaar.ae</a>.
                        </li>
                        <li class="dot-list">
                            We are delighted to announce <b>that EFG Hermes will be providing shuttle bus services between
                                Vida Dubai Marina and The Address Dubai Marina</b>
                            throughout the duration of the conference for your convenience.
                        </li>
                        <br/>
                        <li class="dot-list">Cancellation Policy
                            <ul class="mr-l-40">
                                <li class="dot-empty">
                                    Modifications & free cancellation is permitted <b>before 3<sup>rd</sup> of February, 2024.</b>
                                </li>
                                <li class="dot-empty">
                                    100% cancellation charges will apply for cancellations made after 3<sup>rd</sup> of February, 2024.
                                </li>
                                <li class="dot-empty">
                                    To cancel your booking, <b> Please <a class="link-style text-underline"
                                            href="https://reservations.travelclick.com/115086?groupID=4170603">click
                                            here</a> to cancel your booking. </b>
                                </li>
                            </ul>
                        </li>
                    </ul> -->
                    <!-- As a result of increased demand, the JW Marriott Hotel will be exclusively used as a venue for meetings.
                    <br />
                    <p>
                        For accommodation options in the same area, please refer to the
                        <a class="link-style text-underline" href="https://maps.app.goo.gl/GzFihoyCm5tt2JQC9">hotel location</a>.
                        Please note that the Vida Hotel is presently at full capacity.
                        For inquiries regarding higher category rooms at Vida Hotel, please contact 
                        <a class="link-style text-underline" href="mailto:groups@emaar.ae?cc=OneOnOne@EFG-HERMES.com&subject=EFG%20Hermes%20Conference%20Accommodation%20at%20Vida%20Dubai%20Marina&amp;body=Check%20in:%0D%0ACheck%20out:%0D%0AHotel%20Name:%20Vida%20Marina%0D%0AGroup%20Name:%20EFG%20Hermes%0D%0A">groups@emaar.ae</a>
                    </p> -->
                    <p>We are excited to extend a special accommodation rate to you for your stay at
                        the luxurious <a href="https://london-portman.nobuhotels.com/"><strong>Nobu Hotel London Portman Square</strong></a>. This exclusive
                        rate is applicable for room reservations between <strong>September 8th and
                        September 12th, 2024</strong>. As availability is limited, we recommend booking
                        your stay at your earliest convenience. The special room rate for <strong>single
                        occupancy is GBP 395 per night, which includes VAT and breakfast</strong>.
                        Please be aware that an additional charge of £25 per night will apply if you
                        wish to accommodate an extra guest in the room. Additionally, we are pleased to
                        inform you that we will <strong>arrange transportation to and from the hotel and
                        stadium daily </strong>during the conference.</p>
                        <p>To secure your booking, please <strong><a href="mailto:reserve-portmansquare@nobuhotels.com?cc=londonconference@efg-hermes.com&amp;subject=Accommodation%20at%20Nobu%20Hotel%20-%20EFG%20Hermes%2010th%20Annual%20London%20Conference&amp;body=In%20order%20to%20use%20EFG%20Hermes%20special%20conference%20rate%20at%20Nobu%20Hotel,%20please%20make%20sure%20that%20you%20are%20registered%20through%20the%20conference%20portal%20and%20fill%20the%20info%20below:%0D%0A%0D%0ACode:%20ALLOCEFG24%0D%0AGuest%20full%20name:%0D%0ACheck%20in%20Date:%0D%0ACheck%20out%20Date:%0D%0APlease%20specify%20single%20or%20double%20occupancy:%0D%0AAdditional%20comments:%0D%0AIn%20case%20you%20are%20booking%20more%20than%201%20room,%20please%20fill%20all%20the%20information%20above%20for%20the%20additional%20room(s).%0D%0A">click here</a></strong> and use the code
                        <strong>ALLOCEFG24</strong>.</p><br>
<p><b>Cancellation Policy:</b>
                            Concerning room cancellations, please note that all bookings are made directly through the Hotel, and EFG Hermes is not responsible for any changes or cancellations. Kindly note that reservations must be canceled by <b>August 8th</b> to avoid charges for the entire room stay.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        screenHeight: window.innerHeight + "px",
    }),
};
</script>


<style>
.dot-list {
    list-style-type: disc;
}

.dot-empty {
    list-style-type: circle;
}

.mr-l-40 {
    margin-left: 40px;
}

.link-style {
    color: blue;
}</style>